import React, { useEffect, useRef } from "react";
import styles from "./comp_css/chapter_53.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter53.json";
import Head from "next/head";
export default function Chapter_53() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef();

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start",
  //     });
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current]);
  return (
    <>
         <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Parental Monad unites masculine and feminine, Singularity births cosmos, reflecting Taoist, Kabbalistic, and theurgic harmony."
        ></meta>
        <meta
          property="og:title"
          content=" Parental Monad: The Co-Equal Union of Cosmic Opposites"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Explore the Parental Monad, where masculine and feminine exist in perfect cosmic balance. Through Taoist, Kabbalistic, and cosmological insights, uncover the Singularity as both cause and effect, womb and consciousness. This eternal union births the universe in harmony, mirroring the ecstasy of theurgy, Tantra, and divine archetypes."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=53"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=53"
        ></meta>
        <meta
          name="twitter:title"
          content=" Parental Monad: The Co-Equal Union of Cosmic Opposites"
        ></meta>
        <meta
          name="twitter:description"
          content="Discover the Parental Monad—the ultimate co-equal union of masculine and feminine principles. Drawing from Taoism, Kabbalah, cosmology, and theurgy, this vision reveals the Singularity as both womb and consciousness. Explore how matter, energy, and gravity reflect infinite equality, birthing the universe in ecstatic unity beyond spacetime."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=53" />
      </Head>
     <Common_html BlockData={BlockData} />
    
    </>
  );
}
